import { getUserInfo, getCurrentId, getCode } from '@/api/user'
export default {
  state: {
    userInfo: null,
    currentId: null
  },
  getters: {

  },
  mutations: {
    setUserInfo(state, payload) {
      state.userInfo = payload
    },
    setCurrentIdFn(state, payload) {
      state.currentId = payload
    }
  },
  actions: {
    // 获取用户信息
    async getUserInfoFn({ commit }) {
      try {
        const resData = await getUserInfo();
        commit('setUserInfo', resData);
        return resData;
      } catch (error) {
        console.log(error)
        return false;
      }
    },
    // 获取当前治疗id
    async getCurrentIdFn({ commit }) {
      try {
        const code = await getCode()
        const resData = await getCurrentId(code);
        commit('setCurrentIdFn', resData);
        return resData.id;
      } catch (error) {
        console.log(error)
        return false;
      }
    }
  },
};
